import { TGlobalStores } from '@/editor/stores';
import { CommonController2d } from '../CommonController';
import { modelManager } from '@/editor/manager/entityManager';
import { calMousePosition } from '@/editor/utils';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { VectorPointUtils } from '@/editor/math/VectorPointUtils';

export class OperateFloorplanController extends CommonController2d {
  private _hoverRafId: number | null = null;
  private _latestMousePos: IPoint2d | null = null;

  constructor(globalStores: TGlobalStores) {
    super(globalStores);
  }

  override init() {
    super.init();
  }

  protected override mouseMove(e: MouseEvent): void {
    const { renderer } = this._gs.editorStateStore.sceneInfo;
    this._latestMousePos = VectorPointUtils.vectorToPoint(calMousePosition(e, renderer.domElement));

    if (this._hoverRafId !== null) return;

    this._hoverRafId = requestAnimationFrame(() => {
      this._hoverRafId = null;
      const mousePos = this._latestMousePos;
      this._latestMousePos = null;
      if (!mousePos) return;
      this._setHoveredLayer(modelManager.floorPlanManager.getDxfLayerAtPoint(mousePos));
    });
  }

  protected override mouseUp(e: MouseEvent, dragged: boolean): void {
    if (dragged) return;
    if (e.button === 0) {
      modelManager.floorPlanManager.clickHoveredLayer();
    } else if (e.button === 2) {
      // 右键点击退出
      this.dispose();
      this.exit();
    }
  }

  private _setHoveredLayer(layerName: string | null) {
    modelManager.floorPlanManager.setDxfLayerHover(layerName);
  }

  override dispose() {
    if (this._hoverRafId !== null) {
      cancelAnimationFrame(this._hoverRafId);
      this._hoverRafId = null;
    }
    this._latestMousePos = null;
    this._setHoveredLayer(null);
    super.dispose();
  }
}
